<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row>
				<b-col v-if="false">
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
					<b-button class="btn-close-page float-right mb-2 mr-2" @click="$emit('approvalFlow')" v-b-tooltip.hover title="Approval History"><b-icon icon="clock-history" /></b-button>
				</b-col>
			</b-row>
			<b-card header="Finish Good Quality Inspection" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="FG QC Number" :model="model.requestNumber" />
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="QC By" id="fieldset-process-by" size="sm" :model.sync="model.processByUserName" :isRequired="true" :state="validateState('processByUserName')" :errorMessage="getErrorMessage(errorMessage.processByUserName, 'processByUserName')"   :selected="model.processBy != null ? model.processBy.firstName : ''" @input="getUserInfos" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedProcessBy" :isUpdatable="true"/>
						<app-input-datepicker  id="fieldset-qc-date" label-cols-lg="12" label="QC Date" size="sm" :model.sync="model.qcDate" :isRequired="true" :state="validateState('qcDate')" :errorMessage="getErrorMessage(errorMessage.qcDate, 'qcDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="true" />
					</b-col>
					<b-col cols="12" lg="6">
					</b-col>
				</b-row>
			</b-card>
			<b-card class="mb-3 mt-3">
				<b-row>
					<b-col cols="12" lg="7">
						<app-input-textarea class="textarea-height-auto" :rows="5" id="fieldset-approval-notes" label-cols-sm="4" label-cols-lg="3" label="Approval Notes" label-for="fieldset-approval-notes" size="sm" :model.sync="model.approvalRemarks"  @change="updateData" :isEditable="false" />
					</b-col>
				</b-row>
			</b-card>

		<app-table-input-popup title="QC Result" :bordered="true" :items="finishGoodQcConfirmationDetails" :fields="fieldsFinishGoodQcConfirmationDetail" :busy="isDataLoading" :sort-by.sync="sortByFinishGoodQcConfirmationDetail" :sort-desc.sync="sortDescFinishGoodQcConfirmationDetail" small responsive
			@editButtonMethod="editRowDataFinishGoodQcConfirmationDetail"
			@deleteButtonMethod="deleteRowDataFinishGoodQcConfirmationDetail"
			@showPopupAddMethod="resetDataFinishGoodQcConfirmationDetail()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQcConfirmationDetail()"
			@downloadMethod="downloadFinishGoodQcConfirmationDetail()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQcConfirmationDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQcConfirmationDetail()"
			:showActionButton="false"
			:showEditButton="true"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadFinishGoodQcConfirmationDetail"
			>
			<template #top-row v-if="isShowFinishGoodQcConfirmationDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
							<b-th stacked-heading="Finish Good Quality Inspection">
								<v-select append-to-body label="controlCard" :options="finishGoodQualityInspections"  :value="filterFinishGoodQcConfirmationDetail.finishGoodQualityInspectionId" :reduce="item => item.id" v-model="filterFinishGoodQcConfirmationDetail.finishGoodQualityInspectionId" @search="getFinishGoodQualityInspections" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Control Card">
								<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterFinishGoodQcConfirmationDetail.controlCardId" :reduce="item => item.id" v-model="filterFinishGoodQcConfirmationDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Part">
								<v-select append-to-body label="partNumber" :options="parts"  :value="filterFinishGoodQcConfirmationDetail.partId" :reduce="item => item.id" v-model="filterFinishGoodQcConfirmationDetail.partId" @search="getParts" :filterable="true"></v-select>
							</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( finishGoodQcConfirmationDetailPageSize * (currentFinishGoodQcConfirmationDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
						<template v-slot:cell(finishGoodQcConfirmation)="row">
							{{ row.item != null ? row.item.finishGoodQcConfirmation != null ? row.item.finishGoodQcConfirmation.requestNumber : "" : "" }}
						</template>
						<template v-slot:cell(finishGoodQualityInspection)="row">
							{{ row.item != null ? row.item.finishGoodQualityInspection != null ? row.item.finishGoodQualityInspection.controlCard : "" : "" }}
						</template>
						<template v-slot:cell(controlCard)="row">
							{{ row.item != null ? row.item.controlCard != null ? row.item.controlCard.controlCardNumber : "" : "" }}
						</template>
						<template v-slot:cell(part)="row">
							{{ row.item != null ? row.item.part != null ? row.item.part.partNumber : "" : "" }}
						</template>
						<template v-slot:cell(partName)="row">
									<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
						</template>
						<template v-slot:cell(metodeQc)="row">
									<app-label label-cols-lg="12" size="sm" label="Metode Qc" :model="(row.item.finishGoodQualityInspection != null) ? (row.item.finishGoodQualityInspection.metodeQc != null) ? row.item.finishGoodQualityInspection.metodeQc.name : null : null"  />
						</template>
						<template v-slot:cell(qtyBefore)="row">
									<app-label label-cols-lg="12" size="sm" label="Qty Before" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyBefore : null"  />
						</template>
						<template v-slot:cell(qtyOk)="row">
									<app-label label-cols-lg="12" size="sm" label="Qty OK" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyAfter : null"  />
						</template>
						<template v-slot:cell(qtyPending)="row">
									<app-label label-cols-lg="12" size="sm" label="Qty Pending" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyPending : null"  />
						</template>
						<template v-slot:cell(qtyNg)="row">
							{{ row.item != null ? row.item.qtyNg : "-" }}
						</template>

			<template v-slot:form-add-detail>
				<FinishGoodQcConfirmationDetailInput 
					:openPopup="isShowPopupFinishGoodQcConfirmationDetail"
					:modelId="finishGoodQcConfirmationDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQcConfirmationDetail"/>
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQcConfirmationDetailUpload
					:openPopup="isShowPopupUploadFinishGoodQcConfirmationDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataFinishGoodQcConfirmationDetail"
					:parentId="modelId"
					/>
			</template>
						<template #row-details="row">
							<b-modal v-model="row.item._showDetails" title="Details" ok-only>								<b-card>
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
							<app-label label-cols-lg="12" size="sm" label="Metode Qc" :model="(row.item.finishGoodQualityInspection != null) ? (row.item.finishGoodQualityInspection.metodeQc != null) ? row.item.finishGoodQualityInspection.metodeQc.name : null : null"  />
							<app-label label-cols-lg="12" size="sm" label="Qty Before" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyBefore : null"  />
							<app-label label-cols-lg="12" size="sm" label="Qty OK" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyAfter : null"  />
							<app-label label-cols-lg="12" size="sm" label="Qty Pending" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyPending : null"  />
<app-label :id="'input-finish-good-qc-confirmation-detail-qty-ng-' + row.index" label-cols-lg="12" size="sm" label="Qty Ng" :model="model.qtyNg" />
								</b-card>
							</b-modal>						</template>

		</app-table-input-popup>
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="editRequestAction" 
					:showApproveButton="true" 
					approveButtonTitle="Edit Request"
					:showRejectButton="false"
					:showRevisionButton="false"
					/>
			</Portal>
		</div>
	</div>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import FinishGoodQcConfirmation from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmation';
import FinishGoodQcConfirmationList from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationList';
import FinishGoodQcConfirmationFilter from '@/filters/FinishGoodQcConfirmation/FinishGoodQcConfirmationFilter';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import FinishGoodQcConfirmationDetail from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetail';
import FinishGoodQcConfirmationDetailFilter from '@/filters/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailFilter';
import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import FinishGoodQcConfirmationDetailInput from '@/views/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailInput';
import FinishGoodQcConfirmationDetailUpload from '@/views/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailUpload';


import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	mixins : [toast],
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		FinishGoodQcConfirmationDetailInput,
		FinishGoodQcConfirmationDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,

		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton
	},
	mixins : [validationMixin, toast],
	validations: {
		model: {
			processById: {required},
			qcDate: {required},
			finishGoodQcConfirmationDetail: {required},
		}
	},

	data() {
		return {
			errorMessage : {
				processById: { required : "QC By is Required."},
				qcDate: { required : "QC Date is Required."},
				finishGoodQcConfirmationDetail: { required : "QC Result is Required."},
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsFinishGoodQcConfirmationDetail: [
				//{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none", "label" : "No"}}, 
				// {"finishGoodQualityInspection": { "class" : "th-finish-good-quality-inspection first-child", "label" : "Finish Good Quality Inspection", key: 'finishGoodQualityInspection', sortable: true, isRequired: false }}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard', sortable: true, isRequired: false }}, 
				{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part', sortable: true, isRequired: false }}, 
				{"partName": { "class" : "th-part-name d-stack-none", "label" : "Part Name", key: 'partName', sortable: true, isRequired: false }}, 
				{"metodeQc": { "class" : "th-metode-qc d-stack-none", "label" : "Metode Qc", key: 'metodeQc', sortable: true, isRequired: false }}, 
				{"qtyBefore": { "class" : "th-qty-before d-stack-none", "label" : "Qty Before", key: 'qtyBefore', sortable: true, isRequired: false }}, 
				{"qtyOk": { "class" : "th-qty-ok d-stack-none", "label" : "Qty OK", key: 'qtyOk', sortable: true, isRequired: false }}, 
				{"qtyPending": { "class" : "th-qty-pending d-stack-none", "label" : "Qty Pending", key: 'qtyPending', sortable: true, isRequired: false }}, 
				{"qtyNg": { "class" : "th-qty-ng d-stack-none", "label" : "Qty Ng", key: 'qtyNg', sortable: true, isRequired: false }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelFinishGoodQcConfirmationDetail : {},
			isShowPopupFinishGoodQcConfirmationDetail : false,
			isShowPopupUploadFinishGoodQcConfirmationDetail : false,
			filterFinishGoodQcConfirmation : null,
			currentFinishGoodQcConfirmationPage : 1,
			finishGoodQcConfirmationPageSize: 10,
			sortByFinishGoodQcConfirmation: '',
			sortDescFinishGoodQcConfirmation: '',
			filterFinishGoodQcConfirmationDetail : null,
			currentFinishGoodQcConfirmationDetailPage : 1,
			finishGoodQcConfirmationDetailPageSize: 10,
			sortByFinishGoodQcConfirmationDetail: '',
			sortDescFinishGoodQcConfirmationDetail: '',
			sortingByFinishGoodQcConfirmationDetail: [],
			finishGoodQcConfirmationDetails : [],
			finishGoodQcConfirmationDetailId : '',
			totalFinishGoodQcConfirmationDetailRow : 0,
			isShowFinishGoodQcConfirmationDetailFilter: false,
			isDownloadFinishGoodQcConfirmationDetail: false,
			finishGoodQualityInspections: [],
			controlCards: [],
			parts: [],
			userInfos: [],
			processBys: [],
			isProcessByComboLoading: false,
			backroute: '',
			isUserInfoComboLoading: false,
			isFinishGoodQcConfirmationComboLoading: false,
			isFinishGoodQualityInspectionComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,

		}
	},
	methods : {
		getFinishGoodQcConfirmation : async function(id) {
			this.isDataLoading = true;
			this.getFinishGoodQcConfirmationDetails();

			
			FinishGoodQcConfirmation.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//FinishGoodQcConfirmation.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQcConfirmation = true;
			this.filterFinishGoodQcConfirmation.id = this.modelId;
			FinishGoodQcConfirmation.downloadDataDetail(this, this.filterFinishGoodQcConfirmation).then(result => {
				this.isDownloadFinishGoodQcConfirmation = false;
			}).catch(error => { this.isDownloadFinishGoodQcConfirmation = false; })
		},
		getFinishGoodQcConfirmationDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQcConfirmationDetail);
			if (this.modelId == null) return;
			filter.finishGoodQcConfirmationId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByFinishGoodQcConfirmationDetail != null) {
				this.sortingByFinishGoodQcConfirmationDetail[this.sortByFinishGoodQcConfirmationDetail] = this.sortDescFinishGoodQcConfirmationDetail;
			}
			let currentPage = (this.currentFinishGoodQcConfirmationDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQcConfirmationDetailRow + 1;
				let page = Math.ceil(totalData/this.finishGoodQcConfirmationDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQcConfirmationDetailPageSize = 0;
			// disable paging end
			FinishGoodQcConfirmationDetail.getList(this, filter, this.sortingByFinishGoodQcConfirmationDetail, currentPage , this.finishGoodQcConfirmationDetailPageSize).then(result => {
				this.currentFinishGoodQcConfirmationDetailPage = currentPage + 1;
				this.finishGoodQcConfirmationDetails = result.data;
				this.model.finishGoodQcConfirmationDetail = result.data;
				this.totalFinishGoodQcConfirmationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getFinishGoodQcConfirmations : async function(input) {
			let filter = new FinishGoodQcConfirmationFilter();
			if (input != undefined) {
				filter.requestNumber = input;
			}
			this.isFinishGoodQcConfirmationComboLoading = true;
			FinishGoodQcConfirmation.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQcConfirmations = result.data
				}
				this.isFinishGoodQcConfirmationComboLoading = false;
			})
			.catch(error => {});
		},
		getFinishGoodQualityInspections : async function(input) {
			let filter = new FinishGoodQualityInspectionFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isFinishGoodQualityInspectionComboLoading = true;
			FinishGoodQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspections = result.data
				}
				this.isFinishGoodQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessBy(item) {
			if(item == undefined || item == null) {
				this.model.processByUserName = null;
				this.model.processBy = null;
			} else {
				this.model.processByUserName = item.userName;
				this.model.processBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQcConfirmation.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQcConfirmation.updateData(this, model, id);
				}
			});
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'finishgoodqcconfirmationcreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				FinishGoodQcConfirmation.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							FinishGoodQcConfirmation.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							FinishGoodQcConfirmation.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							FinishGoodQcConfirmation.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				FinishGoodQcConfirmation.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'finishgoodqcconfirmationcreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						FinishGoodQcConfirmation.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				FinishGoodQcConfirmation.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						FinishGoodQcConfirmation.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getFinishGoodQcConfirmations();
		},
		addRowDataFinishGoodQcConfirmationDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQcConfirmationId =  this.modelId;
					FinishGoodQcConfirmationDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getFinishGoodQcConfirmationDetails(true);
						this.isShowPopupFinishGoodQcConfirmationDetail = false;
					})
				} else {
					model.finishGoodQcConfirmationId =  this.modelId;
					FinishGoodQcConfirmationDetail.createData(this, model)
					.then(result => {
						this.getFinishGoodQcConfirmationDetails(true);
						this.isShowPopupFinishGoodQcConfirmationDetail = false;
					})
				}
			}
		},
		async editRowDataFinishGoodQcConfirmationDetail(id) {
			this.finishGoodQcConfirmationDetailId = id;
			this.isShowPopupFinishGoodQcConfirmationDetail = true; 
		},
		async deleteRowDataFinishGoodQcConfirmationDetail(id) {
			FinishGoodQcConfirmationDetail.deleteData(this, id).then(result => { this.getFinishGoodQcConfirmationDetails(); });
		},
		async resetDataFinishGoodQcConfirmationDetail() {
			this.finishGoodQcConfirmationDetailId = "";
			this.isShowPopupFinishGoodQcConfirmationDetail = true;
		},
		async addDataFinishGoodQcConfirmationDetail() {
			FinishGoodQcConfirmationDetail.createData(this, { finishGoodQcConfirmationId: this.modelId })
			.then(result => {
				this.getFinishGoodQcConfirmationDetails(true);
			})
		},
		async addFromClipboardFinishGoodQcConfirmationDetail() {
			let finishGoodQualityInspections = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					finishGoodQualityInspections.push({ finishGoodQualityInspection: item, finishGoodQcConfirmationId: this.modelId });
				});
				FinishGoodQcConfirmationDetail.addFromClipboard(this, finishGoodQualityInspections).then(result => { this.getFinishGoodQcConfirmationDetails() });
			});
		},
		async replaceFromClipboardFinishGoodQcConfirmationDetail() {
			let finishGoodQualityInspections = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					finishGoodQualityInspections.push({ finishGoodQualityInspection: item, finishGoodQcConfirmationId: this.modelId });
				});
				FinishGoodQcConfirmationDetail.replaceFromClipboard(this, finishGoodQualityInspections).then(result => { this.getFinishGoodQcConfirmationDetails() });
			});   
		},
		showPopupUploadFinishGoodQcConfirmationDetail() {
			this.isShowPopupUploadFinishGoodQcConfirmationDetail = true;
		},
		uploadDataFinishGoodQcConfirmationDetail(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQcConfirmationDetail = false; 
		},
		downloadFinishGoodQcConfirmationDetail(modalEvent) {
			this.isDownloadFinishGoodQcConfirmationDetail = true;
			this.filterFinishGoodQcConfirmationDetail.finishGoodQcConfirmationId = this.modelId;
			FinishGoodQcConfirmationDetail.downloadDataDetail(this, this.filterFinishGoodQcConfirmationDetail).then(result => {
				this.isDownloadFinishGoodQcConfirmationDetail = false;
			}).catch(error => { this.isDownloadFinishGoodQcConfirmationDetail = false; })
		},
		saveInputFinishGoodQcConfirmationDetail(item) {
			FinishGoodQcConfirmationDetail.updateDataDetail(this, item, item.id);
		},

		resetModal(modalType) {
			this.isShowPopupUploadFinishGoodQcConfirmationDetail = false; 
			this.isShowPopupFinishGoodQcConfirmationDetail = false; 
			if (modalType == 'FinishGoodQcConfirmationDetail') {
				this.getFinishGoodQcConfirmationDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowFinishGoodQcConfirmationDetailFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterFinishGoodQcConfirmation = new FinishGoodQcConfirmationFilter();
//this.filterFinishGoodQcConfirmation = new FinishGoodQcConfirmationFilter();
		this.filterFinishGoodQcConfirmationDetail = new FinishGoodQcConfirmationDetailFilter();
		//this.getFinishGoodQcConfirmations();
		//this.getFinishGoodQualityInspections();
		//this.getControlCards();
		//this.getParts();
		//this.getUserInfos();


		//this.getFinishGoodQcConfirmations();
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getFinishGoodQcConfirmation(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getFinishGoodQcConfirmation(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		sortByFinishGoodQcConfirmationDetail : {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		sortDescFinishGoodQcConfirmationDetail: {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		currentFinishGoodQcConfirmationDetailPage: {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		finishGoodQcConfirmationDetailPageSize : {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		filterFinishGoodQcConfirmationDetail: {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			},
			deep: true,
		},


	},
}
</script>
